import contract from '@mailobj-browser/front/js/contracts/contract.js'
import gallery from './gallery/gallery.js'

export default contract({
  gallery
})